/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : STEP NAV : STYLES --------------- ++++++++++ */
export default theme => ({
	stepnav: {
		marginTop: pxToEm(20),
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'center',
		justifyContent: 'space-between'
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.thinnest]: {
		stepnav: {
			justifyContent: 'space-around',
			'& .stepnavitem': {
				marginBottom: pxToEm(15)
			}
		}
	}
});
